<template>
    <div class="form-container">

      <div role="alert" class="container alert status-box alert-danger" style="" v-show="error.length">
        <button type="button" aria-label="Close" class="close" @click="error = ''">
          <span aria-hidden="true">×</span>
        </button>
        <div class="row">
          <div class="col media">
            <div class="d-flex mr-2 status-icon">
                <i data-v-17461132="" class="fa fa-remove"></i>
            </div>
            <div class="media-body">
              {{ error }}
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-4">Name</div>
        <div class="col-8">
          <input
              ref="name"
              type="text"
              class="form-control"
              v-model="form.name"
          /> </div>
      </div>

      <div class="row">
        <div class="col-4">Status</div>
        <div class="col-8">
          <dropdown
            :list="getStatusList"
            :value="getStatusName"
            @input="setStatus"
          ></dropdown>
        </div>
      </div>
      <div class="row">
        <div class="col-4">Carrier</div>
        <div class="col-8">
          <auto-complete

            :list="getCarrierNames"
            placeholder="Enter A Carrier"
            :selection="getCarrierName"
            @change="setCarrier"
            showempty
          ></auto-complete>


        </div>
      </div>


      <div class="row">
        <div class="col-4">Billing Address</div>
        <div class="col-8">

          <input
              autocomplete="off"
              type="text"
              ref="autocomplete"
              class="form-control"
              maxlength="256" name="autocomplete-address"
              data-name="autocomplete-address"
              placeholder="Enter An Address"
          />




          <!--<auto-complete-->
            <!--loose-->
            <!--placeholder="Enter Billing Address"-->
            <!--:list="addressNames"-->
            <!--:selection="form.billing_location"-->
            <!--@input="findAddresses"-->
            <!--@change="setAddress"-->
          <!--&gt;</auto-complete>-->
        </div>
      </div>

      <div class="row">
        <div class="col-4">Ink Date</div>
        <div class="col-8">

          <div class="input-group">
            <datepicker
              input-class="form-control"
              wrapper-class="datepicker-wrapper input-group"
              v-model="form.ink_date"
              format="MM/dd/yyyy"
            ></datepicker>
            <div class="input-group-addon clear">
              <i class="fa fa-calendar"></i>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-4">Billing Start Date</div>
        <div class="col-8">

          <div class="input-group">
            <datepicker
                    input-class="form-control"
                    wrapper-class="datepicker-wrapper input-group"
                    v-model="form.billing_startdate"
                    format="MM/dd/yyyy"
            ></datepicker>
            <div class="input-group-addon clear">
              <i class="fa fa-calendar"></i>
            </div>
          </div>
        </div>
      </div>


      <div class="row">
        <div class="col-4">Term</div>
        <div class="col-8">
          <dropdown
              :list="terms"
              v-model="form.term"
          ></dropdown>
        </div>
      </div>

      <div class="row">
        <div class="col-4">Subagent</div>
        <div class="col-8">

          <auto-complete
              v-show="hasPermission(22)"
              :list="userNames"
              :selection="username"
              @input="fetchAgents"
              @change="setAgent"
              loose
          >
          </auto-complete>

        </div>
      </div>

      <div class="row">
        <div class="col-4">Tier</div>
        <div class="col-8">
          <dropdown
                  :list="tiers"
                  v-model="form.tier"
          ></dropdown>
        </div>
      </div>

      <div class="modal-footer">
        <button class="btn btn-clear" @click="$emit('close');" >Cancel</button>
        <button @click="saveAccount" class="btn btn-primary">Save New Account</button>
      </div>

    </div>

</template>
<script type="text/babel">
  import Datepicker from 'vuejs-datepicker';
  import AutoComplete  from '../assets/Autocomplete.vue';
  import Dropdown from '../assets/Dropdown.vue';

  export default {

    data: function(){
      return {
        form:{
          name: '',
          status_id: '8',
          carrier_id: '',
          billing_location: '',
          ink_date:'',
          user_id: '',
          billing_startdate: '',
          term: "36 months",
          tier: null
        },
        username: '',
        addresses:[],
        carriers: [],
        accountStatuses: [],
        location: {},
        terms: ["1 month", "12 months", "24 months", "36 months", "60 months"],
        tiers: [1,2,3,4],
        agents: [],
        error: "",
        autocomplete:{}
      }
    },
    beforeCreate(){

    },
    components:{
      Dropdown,
      AutoComplete,
      Datepicker
    },
    created(){

      this.form.ink_date = moment().format('YYYY-MM-DD HH:mm:ss');
      this.map = new window.TCMap();
      this.fetchStatuses();
      this.fetchCarriers();

      if(this.selected){
        this.form.name = this.selected.name || null;
        this.form.carrier_id = this.selected.carrier_id || null;
        this.form.status_id = this.selected.status_id || null;
        this.form.user_id = this.selected.user_id || null;
        this.username = this.selected.user_name || null;
        this.form.tier = this.selected.tier + '' || null;
      }

    },
    mounted(){
      this.$refs['name'].focus();

      this.autocomplete = new google.maps.places.Autocomplete(
          (this.$refs.autocomplete),
          {
            types: ['geocode']
          });
      this.autocomplete.addListener('place_changed', this.setAddress);
    },
    computed:{
      userNames(){
        if(!this.agents) return []
        return this.agents.map(function(agent){
          return agent.name;
        })
      },
      getSelectedAddress(){
        if(this.form.location){
          return this.form.location.formatted_address
        }
        return '';
      },
      addressNames(){
        return this.addresses.map(function(a){
          return a.formatted_address;
        })
      },
      getStatusList(){
        return this.accountStatuses.map(function(status){
          return status.name;
        });
      },
      getStatusName(){
        var _this = this;

        if(!this.accountStatuses) return false;
        return this.accountStatuses.filter(function(s){
            return s.id == _this.form.status_id;
        }).map(function(s){
          return s.name;
        })[0];
      },

      getCarrierName(){
        var _this = this;
        return this.carriers.filter(function(c){
          return c.carrier_id == _this.form.carrier_id;
        }).map(function(c){
          return c.name;
        })[0];
      },
      getCarrierNames(){
        var _this = this;
        return this.carriers.map(function(c){
          return c.name;
        });
      }
    },
    filters:{
      getLabel(id){
        return this.statuses.filter(function(status){
          return status.id == id;
        }).map(function(status){
          return status.name;
        });
      },
      formatDate(date){
        if(!date) return null;
        return moment(date, 'YYYY-MM-DD').format('MM/DD/YYYY');
      }
    },
    methods:{
      setAgent(userName){
        this.username = userName;
        this.form.user_id = this.agents.filter(function(u){
          return u.name == userName;
        }).map(function(u){
          return u.user_id;
        })[0];

        if(!this.form.user_id) this.username = '';

      },
      fetchAgents(search){

        this.username = search;
        this.$send(this, 'userUsers', { //userMasqueradeUsers
          search: {
            name: search
          },
          columns: ['name']
        }).then(r => {
          this.agents = r.userUsers;
        });
      },


      setCarrier(carrierName){
        this.form.carrier_id = this.carriers.filter(function(c){
          return c.name == carrierName;
        }).map(function(c){
          return c.carrier_id;
        })[0];
      },

      setAddress(){
        var address = this.autocomplete.getPlace();
        this.form.billing_location = address.formatted_address;
      },
      fetchStatuses(){
        var _this = this;

        this.$send(this, 'accountStatuses').then(r => {

          this.accountStatuses = r.accountStatuses;
        });
      },
      fetchCarriers(){

        this.$send(this, 'carriers').then(r => {
          this.carriers = r.carriers;
        });
      },


      setStatus(statusName){
        this.form.status_id = this.accountStatuses.filter(function(status){
          return status.name == statusName;
        }).map(function(status){
          return status.id;
        })[0];
      },

      hasPermission(id){

        if(!this.$store.getters.getUserRoles || !this.$store.getters.getUserRoles[id]) return false;
        var roleCat = this.$store.getters.getUserRoles[id];
        var state = false;
        for(var role_id in roleCat.rolesPermissions){
          if(!roleCat.rolesPermissions.hasOwnProperty(role_id)) continue;
          if(roleCat.rolesPermissions[role_id].state) state = true;
        }

        return state;

      },

      saveAccount(){


        this.error = "";

        if(!this.form.name) this.error = "Please enter a name";
        if(!this.form.carrier_id) this.error = "Please choose a carrier";
        this.form.ink_date = moment(this.form.ink_date).format('YYYY-MM-DD');
        this.form.billing_startdate = moment(this.form.billing_startdate).format('YYYY-MM-DD');

        if(!this.error.length) {
          this.$send(this, 'accountCreate', this.form).then(r => {

            if (!r.account_id) throw new Error(r.error);
            this.$store.commit('setStatus', {
              status: true,
              message: "Account created"
            });

            if(this.selected && this.selected.name){
              this.$emit('saved', r.account_id);
            } else {
              this.$router.push('account-details/' + r.account_id);
            }

          }).catch(err => {
            this.error = err.toString();
          })
        }
      }
    },

    watch:{
      "form.ink_date": function (date) {
          this.form.billing_startdate = moment(date, 'YYYY-MM-DD').add(45, 'days').format('YYYY-MM-DD');
      }
    },
    props: ['selected']
  }
</script>
<style >
  .pac-container {
    z-index: 100001;
  }
</style>


// WEBPACK FOOTER //
// AddAccount.vue?28a2428d